const ROUTES = {
    guest: [
        { ContainerName: "Login", path: "/" },
        { ContainerName: "Login", path: "/login" },
        { ContainerName: "Login", path: "/login/restoring-access", props: { restoring: true } },
        { ContainerName: "Register", path: "/register" },
        { ContainerName: "Register", path: "/register/:plan" },
    ],

    user: [
        { ContainerName: "Dashboard", path: "/", use: ["Menu"] },
        { ContainerName: "Account", path: "/account", use: ["Menu"], props: { account: true } },
        { ContainerName: "Account", path: "/account/password", use: ["Menu"], props: { recovery: true } },
        { ContainerName: "Dashboard", path: "/dashboard", use: ["Menu"] },
        { ContainerName: "Logout", path: "/logout" },
        { ContainerName: "Subscription", path: "/subscription", use: ["Menu"] },
        { ContainerName: "Help", path: "/help", use: ["Menu"] },
        { ContainerName: "Website", path: "/website/:id/design", props: { design: true } },
        { ContainerName: "Website", path: "/website/:id/analytics", use: ["Menu"], props: { analytics: true } },
        { ContainerName: "Website", path: "/website/:id/marketing", use: ["Menu"], props: { marketing: true } },
        { ContainerName: "Website", path: "/website/:id/domain", use: ["Menu"], props: { domain: true } },
        { ContainerName: "Website", path: "/website/:id/content", props: { content: true } },
        { ContainerName: "Website", path: "/website/:id/content/ecommerce", props: { ecommerce: true } },
        { ContainerName: "Website", path: "/website/:id/content/:step", props: { content: true } },
        { ContainerName: "Website", path: "/website/new", props: { new: true } },
    ],
};

let PanelRoots = [];
for (const route of [...ROUTES.guest, ...ROUTES.user]) {
    PanelRoots.push(route.path.replace(/^(\/[^\/]*).*?$/, "$1"));
}

PanelRoots = PanelRoots.filter((v, i, a) => a.indexOf(v) === i).sort((a, b) => (a === b ? 0 : a > b ? 1 : -1));

export default ROUTES;
export { PanelRoots };
